import React from "react";
import { TrendingUp, CheckCircle2, Users } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/common";
import { PROOF } from "@/data/company";

const STATS = PROOF.hasNumbers
  ? [
      { icon: TrendingUp, value: `${PROOF.amount}`, label: `processed ${PROOF.window}` },
      { icon: CheckCircle2, value: `${PROOF.payments}`, label: "successful live payments completed" },
      { icon: Users, value: "First 10", label: "founder-led onboarding for UAE businesses" },
    ]
  : [];

export const ProofSection = () => {
  return (
    <section id="proof" data-testid="proof-section" className="relative py-20 sm:py-28">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            overline="Private beta proof"
            title="Tested with real project payments."
            center
          />
        </Reveal>

        {PROOF.hasNumbers ? (
          <>
            <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-5">
              {STATS.map((s, i) => (
                <Reveal key={s.label} delay={i * 0.08}>
                  <div
                    data-testid={`proof-stat-${i}`}
                    className="h-full bg-white rounded-3xl border border-slate-100 soft-shadow p-7 text-center"
                  >
                    <div className="h-12 w-12 rounded-2xl bg-[#ecfdf3] flex items-center justify-center mx-auto mb-4">
                      <s.icon className="h-6 w-6 text-[#16a34a]" />
                    </div>
                    <p className="font-display text-3xl sm:text-4xl font-extrabold text-[#091630]">{s.value}</p>
                    <p className="text-sm text-slate-500 mt-2 leading-snug">{s.label}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.1}>
              <div className="mt-8 rounded-2xl bg-slate-50 border border-slate-100 p-6 max-w-3xl mx-auto">
                <p data-testid="proof-qualification" className="text-sm text-slate-500 leading-relaxed text-center">
                  {PROOF.qualification}
                </p>
              </div>
            </Reveal>

            <p data-testid="proof-updated" className="text-xs text-slate-400 text-center mt-4">
              Figures updated: {PROOF.updated}. Based on real live payments during private product testing
              (test-mode transactions excluded).
            </p>
          </>
        ) : (
          <Reveal delay={0.1}>
            <p className="mt-10 text-center text-lg text-slate-500 max-w-2xl mx-auto">
              Tested using real UAE project-payment workflows before public launch.
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
};

export default ProofSection;
